export default { sha: '977793512f4d53aa438cb16cecd99d6c9584dca1', buildNumber: 'undefined' }
